import React from 'react'
import PropTypes from 'prop-types'
import { CX } from '../constants'
import Text from './text'
import Icon from './icon'

class Switch extends React.PureComponent {

  handleOnChange = (e) => {
    this.props.onChange(e.currentTarget.checked)
  }

  render() {
    const {
      id,
      label,
      checked,
      onChange,
      onKeyDown,
      disabled,
      labelProps,
      subtitle,
    } = this.props

    const checkboxContainerClasses = CX({
      cursorPointer: !disabled,
      d: 1,
      h40PX: 1,
      w84PX: 1,
      circle: 1,
      border1PX: 1,
      mlAuto: 1,
      bgPrimary: 1,
      borderColorInput: 1,
      bgBrand: checked,
      cursorNotAllowed: disabled,
    })

    const checkboxLabelClasses = CX({
      d: 1,
      m4PX: 1,
      h30PX: 1,
      w30PX: 1,
      circle: 1,
      posAbs: 1,
      aiCenter: 1,
      jcCenter: 1,
      bgSecondary: !checked,
      bgPrimary: checked,
      left0: !checked,
      right0: checked,
    })

    const iconClasses = CX({
      cBrand: checked,
      cSecondary: !checked,
    })

    const icon = checked ? 'check' : 'close'
    const iconSize = checked ? '16px' : '10px'

    return (
      <div className={[_s.d, _s.flexRow, _s.py5, _s.aiCenter].join(' ')}>
        
        <div className={[_s.d, _s.pr10, _s.maxW100PC86PX].join(' ')}>
          <Text {...labelProps} htmlFor={id}>
            {label}
          </Text>
          {
            !!subtitle &&
            <Text color='tertiary' size='small' className={_s.mt5}>
              {subtitle}
            </Text>
          }
        </div>
                
        <label className={checkboxContainerClasses} htmlFor={id}>
          <span className={checkboxLabelClasses}>
            <Icon id={icon} size={iconSize} className={iconClasses} />
          </span>
          <input
            id={id}
            type='checkbox'
            checked={checked}
            onChange={this.handleOnChange}
            disabled={disabled}
            className={[_s.visibilityHidden].join(' ')}
          />
        </label>
      </div>
    )
  }

}

Switch.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  subtitle: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  disabled: PropTypes.bool,
  labelProps: PropTypes.object,
}

export default Switch
